import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomFieldPolicyPermission, CustomFields } from '../../custom-fields.interface';

@Component({
  selector: 'cm-template-custom-group',
  templateUrl: './template-custom-group.component.html',
  styleUrls: ['./template-custom-group.component.scss'],
})
export class TemplateCustomGroupComponent {
  @Input() group: CustomFields.Group;
  @Input() policyPermissions: CustomFieldPolicyPermission;

  @Output() addFieldToGroup = new EventEmitter<CustomFields.Group>();
  @Output() edit = new EventEmitter<CustomFields.Group>();
  @Output() remove = new EventEmitter<CustomFields.Group>();

  showFields = true;

  toggleFields() {
    this.showFields = !this.showFields;
  }

  onRemove(group: CustomFields.Group) {
    this.remove.emit(group);
  }
}
